import { useTranslation } from 'react-i18next';
import styles from './styles';

function UserTakeEmpty() {
  const { t } = useTranslation();
  return (
    <div className="box">
      <div className="icon" />
      <div className="rating-text">
        <div className="no-ratings">
          {t('comparison.userTake.noRatingsYet')}
        </div>
        <div className="would-buy-again">
          {t('comparison.userTake.wouldYouBuyAgain')}
        </div>
        <a
          href={'https://www.research.net/r/make-model-review'}
          className="review-link"
          target="_blank"
          aria-label={t('accessibility.newWindow')}
        >
          <div>{t('comparison.userTake.reviewThisCar')}</div>
        </a>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}

export default UserTakeEmpty;
